<template lang="pug">
v-card.round-xl.pa-4(outlined)
  .d-flex
    .flex-grow-1.pr-2
      .font-medium.text-sm.mb-8 {{ title }}
      .font-semibold.text-2xl.mb-3 {{ count }}
      .d-flex.align-center.font-medium(v-if="percentage")
        template(v-if="percentage > 0")
          v-icon.mr-1.success500--text(size=16) mdi-arrow-up
          .text-xs.mr-2.success500--text {{ percentage }}%
        template(v-else)
          v-icon.mr-1.danger500--text(size=16) mdi-arrow-down
          .text-xs.mr-2.danger500--text {{ percentage }}%
        .text-xs.neutral500--text {{ percentageLabel }}
    div(v-if="percentage && !hideChart")
      apexchart.pt-8(type="area" height="80" width="140" :options="chartOptions" :series="chartOptions.series")
</template>

<script>
export default {
  name: 'StatAreaChartCard',
  props: {
    title: {
      type: String,
      default: null
    },
    count: {
      type: String,
      default: null
    },
    percentage: {
      type: Number,
      default: null
    },
    percentageLabel: {
      type: String,
      default: null
    },
    hideChart: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    chartOptions: {
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      series: [
        { data: [10, 45, 21, 80] },
      ],
      colors: ['#12B76A'],
      chart: {
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false
        },
      },
      xaxis: {
        labels: {
          show: false
        },
        axisTicks: {
          show: false
        }
      },
      yaxis: {
        labels: {
          show: false
        }
      },
      grid: {
        show: false
      }
    }
  })
}
</script>